import React from "react";
import tools from "./tools";
import "./ToolsMarquee.css";

// Identical runs of the list scroll past as one track; the animation shifts it
// by exactly one run's width, so the loop restarts invisibly. Only the first
// run is exposed -- the copies are aria-hidden and out of the tab order so the
// list is not announced or tabbed through three times.
const Run = ({ hidden }) => (
  <div className="gh-marquee-run" aria-hidden={hidden || undefined}>
    {tools.map((tool) => (
      <a
        key={tool.name}
        className="gh-marquee-item"
        href={tool.url}
        target="_blank"
        rel="noopener noreferrer"
        tabIndex={hidden ? -1 : undefined}
      >
        {/* Not lazy: inside a transformed, masked, overflow-hidden track the
            browser never considers these in-viewport, so they would never
            load. Only 8 URLs are unique; the copies come from cache. */}
        <img
          src={tool.avatar}
          alt=""
          width="20"
          height="20"
          referrerPolicy="no-referrer"
        />
        <span>{tool.name}</span>
      </a>
    ))}
  </div>
);

// Two runs is enough as long as one run is wider than the column, which this
// list comfortably is. Add far fewer tools and the seam will show a gap: the
// invariant is (runs - 1) * runWidth >= containerWidth.
const ToolsMarquee = () => (
  <div className="gh-marquee">
    <div className="gh-marquee-track">
      <Run />
      <Run hidden />
    </div>
  </div>
);

export default ToolsMarquee;
